class CartProgress {
  static freeGiftExists = mov.free_gift_from.length !== 0;
  static freeGiftThresholdAmount = parseInt(mov.free_gift_from);

  static async checkCartProgress() {
    const cart = await AjaxCart.getCart();
    const cartValue = parseFloat(cart.items_subtotal_price / 100);
    const freeGiftThresholdReached = cartValue > CartProgress.freeGiftThresholdAmount;
    let giftExistInCart = false;
    let key = false;

    for (let item of cart.items) {
      if (item.handle == mov.free_gift_product.handle || mov.gift_exceptions.indexOf(item.handle) > -1) {
        if (item.properties.hasOwnProperty('_isMov')) {
          giftExistInCart = true;
          key = item.key;
        }
      }
    }

    const formBody = CartProgress.buildFormData(freeGiftThresholdReached, key);

    if (freeGiftThresholdReached) {
      if (!giftExistInCart) await AjaxCart.addToCart(formBody, 'mov');

    } else {
      if (giftExistInCart) await AjaxCart.changeCart(formBody, 'mov');
    }
  }

  static buildFormData(thresholdReached, key) {
    let body;

    if (thresholdReached) {
      body = {
        'id': mov.free_gift_product.variantId,
        'quantity': 1,
        'properties': {
          '_isMov': true
        }
      };
    } else {
      body = {
        'id': key,
        'quantity': 0
      };
    }

    return JSON.stringify(body);
  }
}


subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  CartProgress.checkCartProgress();
});
